import { INTERNAL_ADMIN_ROLE_TO_LABEL, InternalAdminRole } from 'constants/internal-admin-roles';
import BackOfficeInvitation from 'types/models/back-office-invitation';
import { UserRoleLabels } from 'types/models/membership';
import { checkIsInternalAdmin } from 'utils/AccessControl/check-is-internal-admin';

export const useInvitationDescriptor = (invitation?: BackOfficeInvitation): { enterpriseName: string, role: string } => {
  if (!invitation) return { enterpriseName: '', role: '' };

  let enterpriseName: string = invitation.enterprise?.name ?? '';
  let role: string = invitation.role ? UserRoleLabels[invitation.role] : '';

  if (checkIsInternalAdmin(invitation)) {
    enterpriseName = invitation.adminRole === InternalAdminRole.SALES_ADMIN
      ? 'Territory-bound Enterprises'
      : 'All enterprises';
    role = INTERNAL_ADMIN_ROLE_TO_LABEL[invitation.adminRole];
  }

  return { enterpriseName, role };
};